"use strict";

var _toConsumableArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Genomic = exports.GenecDNA = exports.GeneProtein = exports.GeneCDS = void 0;
var react_1 = __importDefault(require("react"));
var util_1 = require("./util");
// note that these are currently put into the style section instead of being
// defined in classes to aid copy and paste to an external document e.g. word
var proteinColor = 'rgb(220,160,220)';
var intronColor = undefined;
var cdsColor = 'rgb(220,220,180)';
var updownstreamColor = 'rgba(250,200,200)';
var utrColor = 'rgb(200,240,240)';
var genomeColor = 'rgb(200,280,200)';
function GeneCDS(_ref) {
  var cds = _ref.cds,
    sequence = _ref.sequence;
  return react_1.default.createElement("span", {
    style: {
      background: cdsColor
    }
  }, (0, util_1.stitch)(cds, sequence));
}
exports.GeneCDS = GeneCDS;
function GeneProtein(_ref2) {
  var cds = _ref2.cds,
    sequence = _ref2.sequence,
    codonTable = _ref2.codonTable;
  var str = (0, util_1.stitch)(cds, sequence);
  var protein = '';
  for (var i = 0; i < str.length; i += 3) {
    // use & symbol for undefined codon, or partial slice
    protein += codonTable[str.slice(i, i + 3)] || '&';
  }
  return react_1.default.createElement("span", {
    style: {
      background: proteinColor
    }
  }, protein);
}
exports.GeneProtein = GeneProtein;
function GenecDNA(_ref3) {
  var utr = _ref3.utr,
    cds = _ref3.cds,
    exons = _ref3.exons,
    sequence = _ref3.sequence,
    upstream = _ref3.upstream,
    downstream = _ref3.downstream,
    includeIntrons = _ref3.includeIntrons,
    collapseIntron = _ref3.collapseIntron,
    intronBp = _ref3.intronBp;
  var chunks = (cds.length ? [].concat(_toConsumableArray(cds), _toConsumableArray(utr)).sort(function (a, b) {
    return a.start - b.start;
  }) : exons).filter(function (f) {
    return f.start !== f.end;
  });
  return react_1.default.createElement(react_1.default.Fragment, null, upstream ? react_1.default.createElement("span", {
    style: {
      background: updownstreamColor
    }
  }, upstream) : null, chunks.map(function (chunk, idx) {
    var _a;
    var intron = sequence.slice(chunk.end, (_a = chunks[idx + 1]) === null || _a === void 0 ? void 0 : _a.start);
    return react_1.default.createElement(react_1.default.Fragment, {
      key: JSON.stringify(chunk)
    }, react_1.default.createElement("span", {
      style: {
        background: chunk.type === 'CDS' ? cdsColor : utrColor
      }
    }, sequence.slice(chunk.start, chunk.end)), includeIntrons && idx < chunks.length - 1 ? react_1.default.createElement("span", {
      style: {
        background: intronColor
      }
    }, collapseIntron && intron.length > intronBp * 2 ? "".concat(intron.slice(0, intronBp), "...").concat(intron.slice(-intronBp)) : intron) : null);
  }), downstream ? react_1.default.createElement("span", {
    style: {
      background: updownstreamColor
    }
  }, downstream) : null);
}
exports.GenecDNA = GenecDNA;
function Genomic(_ref4) {
  var sequence = _ref4.sequence,
    upstream = _ref4.upstream,
    downstream = _ref4.downstream;
  return react_1.default.createElement(react_1.default.Fragment, null, upstream ? react_1.default.createElement("span", {
    style: {
      background: updownstreamColor
    }
  }, upstream) : null, react_1.default.createElement("span", {
    style: {
      background: genomeColor
    }
  }, sequence), downstream ? react_1.default.createElement("span", {
    style: {
      background: updownstreamColor
    }
  }, downstream) : null);
}
exports.Genomic = Genomic;